export const FETCH_SPECIALTIES_REQUEST = "FETCH_SPECIALTIES_REQUEST";
export const UPDATE_SPECIALTY_REQUEST = "UPDATE_SPECIALTY_REQUEST";
export const CREATE_SPECIALTY_REQUEST = "CREATE_SPECIALTY_REQUEST";
export const CHANGE_SPECIALTY_WEIGHT_REQUEST = "CHANGE_SPECIALTY_WEIGHT_REQUEST";
